"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function LegalDetails() {
  return <section id="legal-details" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <div className="md:col-span-8 md:col-start-3">
            <div className="mb-12 text-center">
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-4">
                Legal Notice
              </h2>
              <p className="text-muted-foreground font-sans text-base">
                Last Updated: October 2023
              </p>
            </div>

            <Accordion type="single" collapsible className="w-full space-y-4">
              {}
              <AccordionItem value="item-1" className="border-b border-slate-400 rounded-none">
                <AccordionTrigger className="hover:no-underline rounded-none border-l-2 border-transparent hover:border-ring pl-4 font-serif text-lg md:text-xl font-semibold text-foreground py-5 transition-all duration-200 data-[state=open]:border-ring">
                  Website Owner
                </AccordionTrigger>
                <AccordionContent className="bg-primary/95 text-white p-6 md:p-8 font-sans text-[16px] leading-[1.6] mt-1">
                  <p className="mb-4">
                    In compliance with the Spanish Law on Information Society
                    Services and Electronic Commerce (LSSI-CE), the following
                    information is provided regarding the operator of this
                    website:
                  </p>
                  <ul className="space-y-2 list-none pl-0">
                    <li>
                      <strong className="font-semibold">Operator:</strong> Julio
                      Rosario / Venchandlers Nexus
                    </li>
                    <li>
                      <strong className="font-semibold">Location:</strong>{" "}
                      <span className="text-ring font-medium">
                        Asturias, Spain
                      </span>
                    </li>
                    <li>
                      <strong className="font-semibold">Email:</strong>{" "}
                      <span className="text-ring font-medium">
                        operations@venchandlersnexus.com
                      </span>
                    </li>
                    <li>
                      <strong className="font-semibold">Website:</strong>{" "}
                      <span className="text-ring font-medium">
                        venchandlersnexus.com
                      </span>
                    </li>
                  </ul>
                </AccordionContent>
              </AccordionItem>

              {}
              <AccordionItem value="item-2" className="border-b border-slate-400 rounded-none">
                <AccordionTrigger className="hover:no-underline rounded-none border-l-2 border-transparent hover:border-ring pl-4 font-serif text-lg md:text-xl font-semibold text-foreground py-5 transition-all duration-200 data-[state=open]:border-ring">
                  Business Activity
                </AccordionTrigger>
                <AccordionContent className="bg-primary/95 text-white p-6 md:p-8 font-sans text-[16px] leading-[1.6] mt-1">
                  <p className="mb-4">
                    Venchandlers Nexus operates as an integrated maritime
                    procurement and ship supply coordination brokerage. Our
                    platform connects commercial vessels, ship owners, and
                    maritime operators with trusted maritime suppliers and
                    technical service providers across the Atlantic and
                    Caribbean regions.
                  </p>
                  <p>
                    We facilitate the coordination of provisions, technical
                    supplies, and specialized maritime services across
                    international ports, acting as a professional intermediary to
                    ensure efficient and reliable maritime operations.
                  </p>
                </AccordionContent>
              </AccordionItem>

              {}
              <AccordionItem value="item-3" className="border-b border-slate-400 rounded-none">
                <AccordionTrigger className="hover:no-underline rounded-none border-l-2 border-transparent hover:border-ring pl-4 font-serif text-lg md:text-xl font-semibold text-foreground py-5 transition-all duration-200 data-[state=open]:border-ring">
                  Website Use
                </AccordionTrigger>
                <AccordionContent className="bg-primary/95 text-white p-6 md:p-8 font-sans text-[16px] leading-[1.6] mt-1">
                  <p className="mb-4">
                    By accessing and using this website, you agree to do so in a
                    responsible and lawful manner. Users are strictly prohibited
                    from engaging in the following activities:
                  </p>
                  <ul className="list-disc pl-5 space-y-2">
                    <li>
                      Any illegal activities or actions that violate local,
                      national, or international laws.
                    </li>
                    <li>
                      Attempts to gain unauthorized access to our systems,
                      servers, or any associated networks.
                    </li>
                    <li>
                      Misuse of the platform, including the submission of false
                      inquiries, spam, or malicious software.
                    </li>
                    <li>
                      Any action that imposes an unreasonable or
                      disproportionately large load on our infrastructure.
                    </li>
                  </ul>
                </AccordionContent>
              </AccordionItem>

              {}
              <AccordionItem value="item-4" className="border-b border-slate-400 rounded-none">
                <AccordionTrigger className="hover:no-underline rounded-none border-l-2 border-transparent hover:border-ring pl-4 font-serif text-lg md:text-xl font-semibold text-foreground py-5 transition-all duration-200 data-[state=open]:border-ring">
                  Intellectual Property
                </AccordionTrigger>
                <AccordionContent className="bg-primary/95 text-white p-6 md:p-8 font-sans text-[16px] leading-[1.6] mt-1">
                  <p className="mb-4">
                    All content, text, graphics, design elements, and branding
                    featured on this website are the exclusive property of{" "}
                    <span className="text-ring font-medium">
                      Venchandlers Nexus
                    </span>
                    , unless otherwise explicitly stated.
                  </p>
                  <p>
                    The unauthorized reproduction, distribution, modification,
                    or public display of any materials from this website is
                    strictly prohibited without prior written consent from the
                    rights holder.
                  </p>
                </AccordionContent>
              </AccordionItem>

              {}
              <AccordionItem value="item-5" className="border-b border-slate-400 rounded-none">
                <AccordionTrigger className="hover:no-underline rounded-none border-l-2 border-transparent hover:border-ring pl-4 font-serif text-lg md:text-xl font-semibold text-foreground py-5 transition-all duration-200 data-[state=open]:border-ring">
                  Limitation of Liability
                </AccordionTrigger>
                <AccordionContent className="bg-primary/95 text-white p-6 md:p-8 font-sans text-[16px] leading-[1.6] mt-1">
                  <p className="mb-4">
                    Venchandlers Nexus acts solely in the capacity of a
                    coordinator and broker between commercial vessels and
                    third-party maritime suppliers or service providers. While
                    we make every effort to ensure the reliability and accuracy
                    of the connections we facilitate, we do not directly provide
                    the physical goods or technical services.
                  </p>
                  <p>
                    Consequently, Venchandlers Nexus shall not be held liable
                    for any actions, delays, omissions, or quality issues
                    arising directly from the third-party suppliers or service
                    providers engaged through our brokerage platform.
                  </p>
                </AccordionContent>
              </AccordionItem>

              {}
              <AccordionItem value="item-6" className="border-b border-slate-400 rounded-none">
                <AccordionTrigger className="hover:no-underline rounded-none border-l-2 border-transparent hover:border-ring pl-4 font-serif text-lg md:text-xl font-semibold text-foreground py-5 transition-all duration-200 data-[state=open]:border-ring">
                  Jurisdiction
                </AccordionTrigger>
                <AccordionContent className="bg-primary/95 text-white p-6 md:p-8 font-sans text-[16px] leading-[1.6] mt-1">
                  <p>
                    This website operates under and is governed by the laws of
                    Spain. Any disputes arising from the use of this website or
                    the services described herein shall be subject to the
                    exclusive jurisdiction of the{" "}
                    <span className="text-ring font-medium">
                      Courts of Asturias, Spain
                    </span>
                    .
                  </p>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}